<template>
  <div>
    <Head title="Create Blocker Keyword Response" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/blocker-keywords">Blocker Keyword Response</Link>
      <span class="text-indigo-400 font-medium">/</span> Create
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
            <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full lg:w-1/2" label="Name" />
            <select-input v-model="form.locale" :error="form.errors.locales"  class="pb-8 pr-6 w-full lg:w-1/2" label="Language">
                <option value="en">EN</option>
                <option value="de">DE</option>
            </select-input>
            <textarea-input v-model="form.text" :rows="20" :error="form.errors.text"  class="pb-8 pr-6 w-full" label="Text"></textarea-input>
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Create Response</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import TextareaInput from '@/Shared/TextareaInput'
import SelectInput from '@/Shared/SelectInput'
import MultipleSelectInput from '@/Shared/MultipleSelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
    MultipleSelectInput,
    TextInput,
    TextareaInput
  },
  layout: Layout,
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: '',
        text: '',
        locale: ''
      }),
    }
  },
  methods: {
    store() {
      this.form.post('/blocker-keyword-response')
    },
  },
}
</script>
